




























import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, State, Mutation, Getter} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BSelect from 'buefy/src/components/select/Select.vue';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker.vue';
import {MAFUser} from '@/store/User/types';
import MAFDropdown from '@/components/common/MAFDropdown.vue';
import {Lookup, LookupIcon} from '@/store/types'; // @ is an alias to /src
import * as luxon from 'luxon';
import Slider from '../common/Slider.vue';
import {OptionType} from '@/components/common/types';
import {DateTime} from 'luxon';

const namespace = 'userState';
@Component({
    components: {
        BDatepicker,
        BField,
        BButton,
        BInput,
        BSelect,
        Slider,
        MAFDropdown,
    },
})
export default class LovedOne extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @State('diagnosis', {namespace}) public diagnosis: Lookup | undefined;
    // @State('userType', {namespace}) public userType: string | undefined;
    @Getter('getUserType', {namespace})  public userTypes: string[] | undefined;
    @Getter('getDiagnosis', {namespace})  public diagnoses: string[] | undefined;
    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

    public BASE_URL: string;
    public update: MAFUser;
    public isLoading: boolean;
    public sliderOptions: OptionType[];
    public genderMessage: string;
    public diagnosisMessage: string;
    public birthdateMessage: string;

    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update = this.self;
        this.isLoading = false;
        this.diagnosisMessage = '';
        this.birthdateMessage = '';
        this.genderMessage = '';
        this.sliderOptions = [
            {value: 'male', display: 'Male'},
            {value: 'female', display: 'Female'},
            {value: 'other', display: 'Prefer Not To Say'},
        ];

    }

    public onSelected(selected: OptionType) {
        this.update.loGender = '' + selected.value;
    }
    public clearMessages() {
        this.birthdateMessage = '';
        this.genderMessage = '';
    }
    public parseDate(date: string) {
        return luxon.DateTime.fromISO(date).toJSDate();
    }
    public getNumericAge(): number {
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!this.update.loBirthdate) {
            return 0;
        }
        if (typeof this.update.loBirthdate === 'string') {
            birthday = DateTime.fromISO(this.update.loBirthdate);
        } else if (this.update.loBirthdate instanceof Date) {
            birthday = DateTime.fromJSDate(this.update.loBirthdate);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return diffInYears ? +diffInYears.toFixed(0) : 0;
    }
    get diagnosisIdentifier(): string {
        const self = this;
        if (this.update.loDiagnosis && this.diagnosis && this.diagnosis.values) {
            let found = '';
            this.diagnosis.values.forEach((d) => {
                if (d.display === self.update.loDiagnosis) {
                    found = this.update.loDiagnosis ? this.update.loDiagnosis : '';

                }
            });
            if (found) {
                return found;
            } else {
                return 'Other';
            }

        }
        return '';

    }
    public selectedDiagnosis(selected: LookupIcon) {
        this.update.loDiagnosis = selected.display;
    }
    public async submit(event: any) {
        event.preventDefault();
        this.isLoading = true;
        this.clearMessages();
        let error = false;
        if (this.getNumericAge() < 0) {
            this.birthdateMessage = 'Please enter a valid birthday.';
            error = true;
        }
        if (!error) {
            this.update.signUpPhase = 4;
            this.update.isBanned = false;

            try {
                await this.updateSelfDoc(this.update.toPlainObj());
                this.setSelf(this.update);
            } catch (error) {
                this.$snackbar.open({
                    message: 'Error saving user please try again.',
                    type: 'is-danger',
                    indefinite: true,
                });
            }
        }

        this.isLoading = false;
    }


}
